export const CheckBudgetYear = () => {
    const currentDate = new Date();

    const octoberFirst = new Date(currentDate.getFullYear(), 9, 1);
    if (currentDate >= octoberFirst) {
      return new Date().getFullYear() + 1 + 543;
    } else {
      return new Date().getFullYear() + 543;
    }
};